import { mapState, mapGetters, mapActions } from 'vuex'

export const reasonProviderComputed = {
  ...mapState('reasonProvider', {
    reasonProvider: (state) => state.reasonProvider,
  }),
  ...mapGetters('reasonProvider', ['getReasonProviderDetails']),
}

export const reasonProviderMethods = mapActions('reasonProvider', [
  'setReasonProviderDetails',
])
